import type { IAccountInfo } from 'v2/interfaces/account';

import { INTERCOM_API, INTERCOM_APP_ID } from './settings';

declare global {
  interface Window {
    Intercom: any;
    intercomSettings: any;
  }
}

export function updateIntercom() {
  if (!window.intercomSettings) return;

  window.intercomSettings = {
    ...window.intercomSettings,
    currentUrl: window.location.href,
  };

  window.Intercom('update', window.intercomSettings);
}

export async function setIntercomUser(user: IAccountInfo, belt: string) {
  if (!user?.customer?.intercom_key) return;

  window.intercomSettings = {
    api_base: INTERCOM_API,
    app_id: INTERCOM_APP_ID,
    user_hash: user.customer.intercom_key,
    hide_default_launcher: true,
    eduzzId: user.customer.id,
    originalEduzzId: user.original_customer?.id,
    name: user.customer.name,
    email: user.customer.email,
    isUnity: user.customer.is_clube_black,
    productTag: user.customer.is_clube_black ? 'unity' : user.customer.general_term ? 'pro' : 'lite',
    belt,
    isAccessPolicy: !!user.original_customer && user.customer.id !== user.original_customer.id,
    supportId: user.customer.support_id,
    currentUrl: window.location.href,
  };

  if (window.Intercom) {
    window.Intercom('update', window.intercomSettings);
    return;
  }

  await loadScript();
  window.Intercom('boot', window.intercomSettings);
}

async function loadScript() {
  return new Promise<void>((resolve, reject) => {
    let ic: any = window.Intercom;

    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', window.intercomSettings);

      resolve();
      return;
    }

    ic = function () {
      // eslint-disable-next-line prefer-rest-params
      ic.c(arguments);
    };
    ic.q = [];
    ic.c = function (args: any) {
      ic.q.push(args);
    };
    window.Intercom = ic;

    const script = document.createElement('script');
    script.src = 'https://widget.intercom.io/widget/' + INTERCOM_APP_ID;
    script.type = 'text/javascript';
    script.async = true;
    script.onload = () => resolve();
    script.onerror = (err) => reject(err);

    document.head.appendChild(script);
  });
}
